/**
 * Created by Jose on 18/05/2018
 */
import { Injectable } from '@angular/core';
import { ModalController, Platform } from 'ionic-angular';
import { API } from '../services/api';
import { AppVersion } from '@ionic-native/app-version';
import { LocalStorageService } from '../services/localStorage.service';

@Injectable()
export class CheckVersion {

  constructor(private appVersion: AppVersion,
              private modalCtrl: ModalController,
              private api: API,
              private platform: Platform,
              private localStorage: LocalStorageService,
  ) {
  }

  getAppVersion(): Promise<any> {
    let device = '';
    let initOk = true;
    let newVersion = false;
    let storeLink = '';
    if (this.platform.is('android')) device = 'android';
    if (this.platform.is('ios')) device = 'ios';

    return this.appVersion.getPackageName().then(packageName => {
      return this.api.obtenerVersionMinima(packageName).then(versionMinima => {
        if (versionMinima.status_code == '200') {
          const versions = versionMinima.data.versions;
          console.log('VERSIONES EN API' + JSON.stringify(versions))
          if (versions != null) {
            return this.appVersion.getVersionNumber().then(versionNumber => {
              versions.forEach(element => {
                if (element.id == device) {
                  storeLink = element.link;
                  const lastVersion = element.last_version;
                  const minVersion = element.min_version_required;
                  console.log('VERSION DE LA APP EN API ' + JSON.stringify(versionNumber))
                  const statusVersionLast = this.compare(versionNumber, lastVersion);
                  const statusVersionMin = this.compare(versionNumber, minVersion);

                  if (statusVersionMin == -1) {
                    newVersion = true;
                    initOk = false;
                  } else if (statusVersionLast == -1) {
                    newVersion = true;
                    initOk = true;
                  }
                }
              });
              const v = { initOk, newVersion, storeLink };
              return this.localStorage.setCheckVersionApp(v);
            });
          }
        }
      });
    }).catch(error => { });
    // } else {
    // console.log("Ya hemos mirado en api la versión. No hago nada. Solo leer de local.");
    // }
    // });
  }

  checkAppVersion(): Promise<any> {
    return this.localStorage.getCheckVersionApp().then(response => {
      if (response.initOk == false) {
        this.createModalVersion(false, response.storeLink);
      } else if (response.newVersion == true) {
        this.createModalVersion(true, response.storeLink);
      }
      return response.initOk;
    }).catch(error => { return true; });

  }

  createModalVersion(cancelBtnFlag, storeLink) {
    const popUp = this.modalCtrl.create('CheckVersion', { storeLink, cancelBtn: cancelBtnFlag });
    popUp.present();
    popUp.onDidDismiss((data) => {
    });
  }

  compare(a, b) {
    if (a === b) {
      return 0;
    }

    const aComponents = a.split('.');
    const bComponents = b.split('.');

    const len = Math.min(aComponents.length, bComponents.length);

    // loop while the components are equal
    for (let i = 0; i < len; i++) {
      // A bigger than B
      if (parseInt(aComponents[i], 10) > parseInt(bComponents[i], 10)) {
        return 1;
      }

      // B bigger than A
      if (parseInt(aComponents[i], 10) < parseInt(bComponents[i], 10)) {
        return -1;
      }
    }

    // If one's a prefix of the other, the longer one is greater.
    if (aComponents.length > bComponents.length) {
      return 1;
    }

    if (aComponents.length < bComponents.length) {
      return -1;
    }

    // Otherwise they are the same.
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/services/checkVersion.ts